import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Testimonial from "./Testimonial";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import "../../index.css";
import { Flex } from "@chakra-ui/react";

const TestimonialSwiper = ({ ...props }) => {
  const reviews = [
    {
      title: "Ravi Sharma, Software Developer",
      review:
        "Filing my Income Tax Return has never been easier! 360fintax handled everything efficiently, and their team was always available to answer my questions. Highly recommend their services!",
    },
    {
      title: "Priya Singh, Business Owner",
      review:
        "360fintax made my GST filing process stress-free. Their expertise saved me time and ensured accuracy. I’m so glad I found them!",
    },
    {
      title: "Amit Patel, Entrepreneur",
      review:
        "Starting my business seemed daunting, but 360fintax walked me through the entire registration process. Their team is professional, responsive, and truly knowledgeable.",
    },
    {
      title: "Anuj Mehta, Chartered Accountant",
      review:
        "360fintax is a lifesaver for busy professionals like me. They simplified my ITR filing process, and their prompt service exceeded my expectations.",
    },
  ];

  return (
    <>
      <Flex
        height={{ base: "300px", md: "300px", lg: "400px" }}
        w="full"
        alignItems="center"
        px={{ base: "5", md: "10", lg: "20" }}
        {...props}
      >
        <Swiper
          // navigation={true}
          modules={[Navigation, Autoplay]}
          className="swiper"
          loop={true}
          style={{ padding: "20px 0px" }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            840: { slidesPerView: 1 }, // 1 slide for mobile
            1024: { slidesPerView: 2 }, // 2 slides for desktop
          }}
        >
          {reviews.map((testimonial) => (
            <SwiperSlide>
              <Testimonial
                review={testimonial.review}
                name={testimonial.title}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Flex>
    </>
  );
};

export default TestimonialSwiper;
